import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { generateTemplate } from "configs/utils/Excel";
import { DATE_FORMAT_DD_MM_YYYY_T_HH_mm_ss } from "constants/DateConstant";
import dayjs from 'dayjs';

export const getAllMasterJadwal = createAsyncThunk("masterJadwal/getAllMasterJadwal", 
	async (_, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get('v1/master/jadwal');
			return response.data;
		} catch (e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const getMasterJadwalById = createAsyncThunk("masterJadwal/getMasterJadwalById", 
	async (id, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.get(`v1/master/jadwal/${id}`);
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const deleteMasterJadwal = createAsyncThunk("masterJadwal/deleteMasterJadwal", 
	async (id, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			await jwtAuthAxios.delete(`v1/master/jadwal/${id}`);
			return id;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const addMasterJadwal = createAsyncThunk("masterJadwal/addMasterJadwal",
	async (payload, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.post('v1/master/jadwal', payload);
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const updateMasterJadwal = createAsyncThunk("masterJadwal/updateMasterJadwal", 
	async (payload, { rejectWithValue }) => {
		try {
			const token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const response = await jwtAuthAxios.put('v1/master/jadwal', payload);
			return response.data;
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

export const downloadTemplateExcel = createAsyncThunk("masterJadwal/downloadTemplateExcel",
	async (payload, { rejectWithValue }) => {
		try {
			const workbook = await generateTemplate(payload);

			// Save to blob
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { 
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
			});
      const url = URL.createObjectURL(blob);

      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.download = 'skala_penilaian_data.xlsx';

      // Trigger a click on the link to initiate the download
      link.click();

      // Cleanup
      URL.revokeObjectURL(url);
		} catch(e) {
			rejectWithValue({
				message: e.data.message || e.message
			})
		}
	}
);

const masterJadwal = {
	hari: '',
	jamMulai: dayjs('1980-01-01', DATE_FORMAT_DD_MM_YYYY_T_HH_mm_ss),
	jamSelesai: dayjs('1980-01-01', DATE_FORMAT_DD_MM_YYYY_T_HH_mm_ss),
};

const initialState = {
	allMasterJadwal: [],
	single: { ...masterJadwal },
	status: {
		loading: false
	}
}

const masterJadwalSlice = createSlice({
	name: "masterJadwal",
	initialState,
	reducers: {
    onRefreshForm: (state) => {
			state.single = initialState.single
      state.status = initialState.status;
    },
    onRefreshStatus: (state) => {
      state.status = initialState.status;
    },
    onChangeData: (state, action) => ({
      ...state, 
      ...action.payload
    }),
	},
	extraReducers: {
		[getAllMasterJadwal.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getAllMasterJadwal.fulfilled]: (state, action) => {
			state.allMasterJadwal = action.payload;
			state.status.loading = false;
		},
		[getAllMasterJadwal.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[getMasterJadwalById.pending]: (state, action) => {
			state.status.loading = true;
		},
		[getMasterJadwalById.fulfilled]: (state, action) => {
			state.single = action.payload;
			state.status.loading = false;
		},
		[getMasterJadwalById.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[addMasterJadwal.pending]: (state, action) => {
			state.status.loading = true;
		},
		[addMasterJadwal.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[addMasterJadwal.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[deleteMasterJadwal.pending]: (state, action) => {
			state.status.loading = true;
		},
		[deleteMasterJadwal.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[deleteMasterJadwal.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[updateMasterJadwal.pending]: (state, action) => {
			state.status.loading = true;
		},
		[updateMasterJadwal.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[updateMasterJadwal.rejected]: (state, action) => {
			state.status.loading = false;
		},
		[downloadTemplateExcel.pending]: (state, action) => {
			state.status.loading = true;
		},
		[downloadTemplateExcel.fulfilled]: (state, action) => {
			state.status.loading = false;
		},
		[downloadTemplateExcel.rejected]: (state, action) => {
			state.status.loading = false;
		},
	}
})

export const { 
	onRefreshForm,
	onRefreshStatus,
	onChangeData,
} = masterJadwalSlice.actions;

export const selectMasterJadwal = (state) => state.masterJadwal;

export default masterJadwalSlice.reducer;